module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "player"
  }, [_c('div', {
    staticClass: "player-controls"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.playerSkipBack
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#000000",
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0V0z",
      "id": "replay_a"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "replay_b"
    }
  }, [_c('use', {
    attrs: {
      "overflow": "visible",
      "xlink:href": "#replay_a"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "clip-path": "url(#replay_b)",
      "d": "M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.1 11H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1c.2.1.3.2.5.3s.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z"
    }
  })])]), _vm._v(" "), (_vm.loading) ? _c('button', {
    staticClass: "button is-loading",
    attrs: {
      "disabled": ""
    }
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 5v14l11-7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.playerPlaying && !_vm.loading) ? _c('button', {
    on: {
      "click": _vm.playerPlay
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#000000",
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 5v14l11-7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.playerPlaying && !_vm.loading) ? _c('button', {
    on: {
      "click": _vm.playerPause
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#000000",
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.playerSkipAhead
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#000000",
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "d": "M24 24H0V0h24v24z",
      "id": "forward_a"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "forward_b"
    }
  }, [_c('use', {
    attrs: {
      "overflow": "visible",
      "xlink:href": "#forward_a"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "clip-path": "url(#forward_b)",
      "d": "M9.6 13.5h.4c.2 0 .4-.1.5-.2s.2-.2.2-.4v-.2s-.1-.1-.1-.2-.1-.1-.2-.1h-.5s-.1.1-.2.1-.1.1-.1.2v.2h-1c0-.2 0-.3.1-.5s.2-.3.3-.4.3-.2.4-.2.4-.1.5-.1c.2 0 .4 0 .6.1s.3.1.5.2.2.2.3.4.1.3.1.5v.3s-.1.2-.1.3-.1.2-.2.2-.2.1-.3.2c.2.1.4.2.5.4s.2.4.2.6c0 .2 0 .4-.1.5s-.2.3-.3.4-.3.2-.5.2-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.4-.1-.6h.8v.2s.1.1.1.2.1.1.2.1h.5s.1-.1.2-.1.1-.1.1-.2v-.5s-.1-.1-.1-.2-.1-.1-.2-.1h-.6v-.7zm5.7.7c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5zM4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "scrub"
  }, [_c('input', {
    style: ({
      background: ("linear-gradient( to right, #00cdbd 0%, #00cdbd " + _vm.percentElapsed + "%, #bfe0dd " + _vm.percentElapsed + "%, #bfe0dd 100% )")
    }),
    attrs: {
      "type": "range",
      "min": "0",
      "max": _vm.duration
    },
    domProps: {
      "value": _vm.seek
    },
    on: {
      ":data-percent": _vm.percentElapsed,
      "change": function($event) {
        _vm.playerSeek($event.target.value)
      },
      "input": function($event) {
        _vm.setSeek(parseInt($event.target.value))
      }
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('p', {
    staticClass: "playerInfo"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.playingEpisode.title)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formattedCurrentTime) + " | " + _vm._s(_vm.formattedDuration))])]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('p', {
    staticClass: "playerInfo"
  }, [_vm._v("Loading...")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c20c68b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/AudioPlayer.vue
// module id = 763
// module chunks = 1